import api from './api';

export const studentService = {
  // ============================================
  // TEACHER ENDPOINTS
  // ============================================

  // Get all students for the current teacher
  async getStudents() {
    const response = await api.get('/students');
    return response.data;
  },

  // Get a single student by ID
  async getStudent(studentId) {
    const response = await api.get(`/students/${studentId}`);
    return response.data;
  },

  // Create a new student
  async createStudent(data) {
    const response = await api.post('/students', {
      name: data.name,
      avatar: data.avatar,
      grade: data.grade,
      pin: data.pin,
    });
    return response.data;
  },

  // Update a student
  async updateStudent(studentId, data) {
    const response = await api.put(`/students/${studentId}`, data);
    return response.data;
  },

  // Delete a student
  async deleteStudent(studentId) {
    const response = await api.delete(`/students/${studentId}`);
    return response.data;
  },

  // Get student progress (teacher view)
  async getStudentProgress(studentId) {
    const response = await api.get(`/students/${studentId}/progress`);
    return response.data;
  },

  // Update student PIN
  async updateStudentPin(studentId, pin) {
    const response = await api.put(`/students/${studentId}/pin`, { pin });
    return response.data;
  },

  // Reset student PIN to random
  async resetStudentPin(studentId) {
    const response = await api.post(`/students/${studentId}/reset-pin`);
    return response.data;
  },

  // ============================================
  // STUDENT SELF-SERVICE ENDPOINTS
  // ============================================

  // Get my profile (student)
  async getMyProfile() {
    const response = await api.get('/students/me/profile');
    return response.data;
  },

  // Get my complete game data (student)
  async getMyGameData() {
    const response = await api.get('/students/me/game-data');
    return response.data;
  },

  // Update my avatar (student)
  async updateMyAvatar(avatar) {
    const response = await api.put('/students/me/avatar', null, {
      params: { avatar },
    });
    return response.data;
  },

  // Refresh student data - fetch fresh profile from server
  async refreshMyData() {
    const response = await api.get('/students/me/profile');
    return response.data;
  },
};

export default studentService;
